module.exports = __webpack_public_path__ + "static/media/workshop.a8488305.webp";